import { useMemo } from 'react'
import { OrderStepButtonsBase, OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { OrderStepButtonsDefaultBaseComponent, OrderStepButtonsNewStyleBaseComponent } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent'
import { AdjustmentDownloadButtonCSV, AdjustmentPdfPreview, AdjustmentDownloadPdfTemplateButton, AdjustmentDownloadButtonPDF } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderAdjustmentDeliveryNoteLayout/AdjustmentButtons'

const AdjustmentDeliveryNoteCreateNoPermissionButtons: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsDefaultBaseComponent {...{ data, onSubmit, hookFunction: useAdjustmentDeliveryNoteCreateNoPermissionsStepButtonsLogic, ...rest }} className='mr-8' />
    )
}

const useAdjustmentDeliveryNoteCreateNoPermissionsStepButtonsLogic = ({ data }: OrderStepButtonsBaseComponentProps) => {
    const { t } = useTwinTranslation()
    const name = 'adjustment_delivery_note_create_no_permissions_step_buttons'
    const Order = data?.header
    const showButtonsByPricesPermission = !data?.header?.hidePrices

    const defaultButtons = [{ "id": "previewAdjustmentDeliveryNotePDF" }, { "id": "downloadAdjustmentDeliveryNote" }, { "id": "duplicateAdjustmentDeliveryNote" }]

    const adjustmentDeliveryNoteDownloadCSVText = t('downloadCsv', 'Descargar csv')
    const adjustmentDeliveryNotePreviewPDFText = t('previewPdfTemplate', 'Previsualizar plantilla PDF')
    const adjustmentDeliveryNoteDownloadPDFTemplateText = t('downloadPdfTemplate', 'Descargar plantilla PDF')
    const adjustmentDeliveryNoteDownloadPDFText = t('downloadPdf', 'Descargar PDF')

    const ButtonComponents: OrderStepButtonsBase = useMemo(() => {
        return {
            downloadAdjustmentCsv: {
                component: AdjustmentDownloadButtonCSV,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: adjustmentDeliveryNoteDownloadCSVText,
                    id: 'downloadAdjustmentCsv',
                    Order,
                    typeTemplate: 'adjustmentDeliveryNote'
                }
            },
            previewAdjustmentDeliveryNotePDF: {
                component: AdjustmentPdfPreview,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: adjustmentDeliveryNotePreviewPDFText,
                    id: 'previewAdjustmentDeliveryNotePDF',
                    key: 'previewAdjustmentDeliveryNotePDF',
                    Order,
                    typeTemplate: 'adjustmentDeliveryNote'
                }
            },
            downloadAdjustmentDeliveryNoteTemplate: {
                component: AdjustmentDownloadPdfTemplateButton,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: adjustmentDeliveryNoteDownloadPDFTemplateText,
                    id: 'downloadAdjustmentDeliveryNoteTemplate',
                    key: 'downloadAdjustmentDeliveryNoteTemplate',
                    Order,
                    typeTemplate: 'adjustmentDeliveryNote'
                }
            },
            downloadAdjustmentDeliveryNote: {
                component: AdjustmentDownloadButtonPDF,
                showButton: showButtonsByPricesPermission,
                extraProps: {
                    title: adjustmentDeliveryNoteDownloadPDFText,
                    id: 'downloadAdjustmentDeliveryNote',
                    Order,
                    typeTemplate: 'adjustmentDeliveryNote'
                }
            },
        }
    }, [Order, adjustmentDeliveryNoteDownloadCSVText, adjustmentDeliveryNoteDownloadPDFTemplateText, adjustmentDeliveryNoteDownloadPDFText, adjustmentDeliveryNotePreviewPDFText, showButtonsByPricesPermission])

    return { name, ButtonComponents, defaultButtons }
}

export const AdjustmentDeliveryNoteCreateNoPermissionButtonsNew: React.FC<OrderStepButtonsBaseComponentProps> = ({ data, onSubmit, ...rest }) => {
    return (
        <OrderStepButtonsNewStyleBaseComponent {...{ data, onSubmit, hookFunction: useAdjustmentDeliveryNoteCreateNoPermissionsStepButtonsLogic, ...rest }} className='mr-8' />
    )
}

export default AdjustmentDeliveryNoteCreateNoPermissionButtons